import { render, staticRenderFns } from "./ColorsStep.vue?vue&type=template&id=166ddaf4"
import script from "./ColorsStep.vue?vue&type=script&lang=js"
export * from "./ColorsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports